module.exports = [
	{
		"displayName": "Express Parcel",
		"serviceMethodType": "EXPRESS",
		"serviceType": "PARCEL",
		"verticals": [
			"furniture",
			"art"
		],
		"dealerShortExplanation": "Expedited mail or package delivery",
		"dealerSuggestedDays": "1 to 3 days"
	},
	{
		"displayName": "Front Door Freight",
		"serviceMethodType": "FRONT_DOOR",
		"serviceType": "FREIGHT",
		"verticals": [
			"furniture",
			"art"
		],
		"dealerShortExplanation": "Scheduled delivery to customer's front door",
		"dealerSuggestedDays": "4+ days"
	},
	{
		"displayName": "Messenger",
		"serviceMethodType": "MESSENGER",
		"serviceType": "PARCEL",
		"verticals": [
			"furniture",
			"art"
		],
		"dealerShortExplanation": "Fast, hand delivered",
		"dealerSuggestedDays": "1 to 2 days"
	},
	{
		"displayName": "Standard Parcel",
		"serviceMethodType": "STANDARD",
		"serviceType": "PARCEL",
		"verticals": [
			"furniture",
			"art"
		],
		"dealerShortExplanation": "Mail or package delivery",
		"dealerSuggestedDays": "4+ days"
	},
	{
		"displayName": "White Glove",
		"serviceMethodType": "STANDARD",
		"serviceType": "WHITE_GLOVE",
		"verticals": [
			"furniture",
			"art"
		],
		"dealerShortExplanation": "Scheduled delivery to customer's room of choice",
		"dealerSuggestedDays": "4+ days"
	},
	{
		"displayName": "Expedited White Glove",
		"serviceMethodType": "EXPRESS",
		"serviceType": "WHITE_GLOVE",
		"verticals": [
			"furniture",
			"art"
		],
		"dealerShortExplanation": "Expedited scheduled delivery to customer's room of choice",
		"dealerSuggestedDays": "4+ days"
	},
	{
		"displayName": "Express",
		"serviceMethodType": "EXPRESS",
		"serviceType": "PARCEL",
		"verticals": [
			"jewelry",
			"fashion"
		],
		"dealerShortExplanation": "Expedited mail or package delivery",
		"dealerSuggestedDays": "1 to 3 days"
	},
	{
		"displayName": "Messenger",
		"serviceMethodType": "MESSENGER",
		"serviceType": "PARCEL",
		"verticals": [
			"jewelry",
			"fashion"
		],
		"dealerShortExplanation": "Fast, hand delivered",
		"dealerSuggestedDays": "1 to 2 days"
	},
	{
		"displayName": "Standard",
		"serviceMethodType": "STANDARD",
		"serviceType": "PARCEL",
		"verticals": [
			"jewelry",
			"fashion"
		],
		"dealerShortExplanation": "Mail or package delivery",
		"dealerSuggestedDays": "4+ days"
	}
];


//////////////////
// WEBPACK FOOTER
// ./~/dibs-static/admin/json/dealer/shipping/1/serviceMethodDisplay.json
// module id = 2824
// module chunks = 64